<div class="row accessories-carousel m-t-lg">
  <div class="col-12">
    <div class="row">
      <div class="col-1 acc-carret left" *ngIf="maxLength > carousalLength">
        <a
          id="left-carret"
          class="carret-link"
          [class.disabled]="startIndex === 0"
          aria-label="clickable action"
          (click)="moveLeft()"
        >
          <i class="fa fa-angle-left icon-24"></i>
        </a>
      </div>
      <div class="col-1 acc-carret right" *ngIf="maxLength > carousalLength">
        <a
          id="right-carret"
          class="carret-link"
          [class.disabled]="endIndex === maxLength"
          aria-label="clickable action"
          (click)="moveRight()"
        >
          <i class="fa fa-angle-right icon-24"></i>
        </a>
      </div>
      <div
        [ngClass]="i === 0 ? 'product-view-thumb-spacing' : ''"
        class="col-3 text-center n-padding"
        *ngFor="let img of itemArray | slice: startIndex : endIndex; let i = index"
      >
        <div *ngIf="img.imagePath; else noImageAvailable">
          <a
            id="carousal-image"
            attr.aria-label="{{ image }}"
            href="javascript:void(0);"
            (click)="showImage(extTmoImagesUrl + img.imagePath)"
            id="cta-length-2_{{ i }}"
          >
            <img
              class="img-fluid inline-block"
              [src]="extTmoImagesUrl + img.imagePath || ''"
              alt="FPO Image"
            />
          </a>
        </div>
        <ng-template #noImageAvailable>
          <img id="no-image" class="img-fluid" [src]="imageUrl" alt="FPO Image" />
        </ng-template>
      </div>
    </div>
  </div>
</div>
